export default "__VITE_ASSET__PO47s27L__"